<script setup>
import { t } from "@/app/composables/useI18n"
import { api } from "@/services"
import { useUserService } from "@/user-account/composables/useUserService"
import { computed, onMounted, ref } from "vue"
import { useBetStore } from "../../../../../../store"
import Session from "../Session.vue"

const store = useBetStore()

const allTickets = ref([])
const loading = ref(false)
const totalCount = ref(0)
const page = ref(1)
const { isAuthenticated, activeWallet } = useUserService()

async function fetchBets(cp = 1) {

}

onMounted(fetchBets)

function handleFetchMore() {
  page.value = page.value + 1
  fetchBets(page.value)
}
</script>

<template>
  <div v-if="allTickets.length > 0">
    <div v-for="ticket in allTickets" :key="ticket.id">
      <Session :ticket="ticket" :result="34" />
    </div>
  </div>
  <div v-else>
    <div class="empty-data">
      {{ t("general.dont_have") }} {{ t("general.casino") }} {{ t("general.bets") }}
    </div>
  </div>
  <button
    v-if="allTickets.length < totalCount && allTickets.length != 0"
    class="load-more"
    @click="handleFetchMore"
  >
    Load More
  </button>
</template>

<style lang="scss" scoped>
.load-more {
  background: var(--be-primary-btn);
  height: 45px;
  width: calc(100% - 32px);
  border-radius: 8px;
  margin: 10px 16px;
  color: var(--be-primary-btn-label);
}
.empty-data {
  text-align: center;
  margin: 40px 0;
}
</style>
